// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
	function selectHotelDefault(){
		let site ='',
			selected = document.getElementById("propertyName")
		if(IS_LIVE){
			site = location.host
		}else{
			
			const search = location.search.replace('?',''),
				searchSlip =  search.split('&');

			searchSlip.forEach((Element) => {
				let elemArray = Element.split('=')
				if(elemArray[0].indexOf('site_id')>-1)
					site = elemArray[1]
			})
		} 
		
		if(site=='1519' || site.indexOf('theperryhotel')>-1){
			selected.selectedIndex = 3
		}else if(site=='1518' || site.indexOf('crookedriverlodge')>-1){
			selected.selectedIndex = 2
		}else if(site=='1517' || site.indexOf('thebayviewinn')>-1){
			selected.selectedIndex = 1
		}else{
			if(document.getElementsByClassName("res-search")[0]!==undefined)
				document.getElementsByClassName("res-search")[0].classList.remove('hidden')
		}
	}
	$(document).ready(function () {
		//select hotel
		selectHotelDefault()
		//Api weather
		weather();
		// Main Nav Dropdown
		$("#primary-nav li, .prop").hover(function(){
			$(this).addClass("hover");
			$('ul',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul',this).fadeOut(200);
		});
		$('#menu-btn').click(function(e){
			e.preventDefault();
			$('#primary-nav').toggleClass('active');
		});

		let proeprtyName = document.querySelector( "#propertyName" )
		let proeprtyNameOptions = [...proeprtyName.querySelectorAll( "option" )]
		let prop_id = null;
		proeprtyName.addEventListener( "change", (e) => {
			prop_id = proeprtyNameOptions[ e.target.selectedIndex ].dataset.id
		} )


		$('#booking-form').submit(function(event) { //NEW LANDING PAGE WIDGET ID ADDED
			event.preventDefault();
			var form = $(this).attr('id');
			var promoCode = '';
			var linkerParam;
			var children = ($('#'+form+' select[name="children"]').val()) ? $('#'+form+' select[name="children"]').val() : $('#'+form+' input[name="child"]').val();
			var adults = ($('#'+form+' select[name="adults"]').val()) ? $('#'+form+' select[name="adults"]').val() : $('#'+form+' input[name="adults"]').val();
			var checkIn = $('#'+form+' input[name="arrival_date"]');
			var numDays = $('#'+form+' #nights').val();
			var propertyId = $('#'+form+' select#propertyName').val()
			var checkInVal = checkIn.val();
			var checkInArray = checkInVal.split('/');
			var checkInYear = checkInArray[2];
			var checkInMonth = parseInt(checkInArray[0]) - 1;
			var checkInMonthAdj = checkInArray[0];
			var checkInDay = checkInArray[1];

			// ga(function(tracker) {
			// 	 linkerParam = tracker.get('linkerParam');
			// });

			var bookingURL ="";
			let currentId = "";

			var idForm = "";

			if( prop_id ) idForm = prop_id

			switch (site_id) {
				case 1519:

					currentId = "17662";
					bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&children='+ children;

					break;

				case 1517:
					currentId = "17665";
					bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&child='+ children;
					
					break;

				case 1518:
					currentId = "17663";
					bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&child='+ children;
					
					break;

				case 1696:
					currentId = "17664";
					bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&child='+ children;
					
					break;

				default:
					// bookingURL = 'https://www.bookonthenet.net/east/premium/eresmain.aspx?id='+propertyId+'&arrival_date='+ checkInYear + '-' + checkInMonthAdj + '-' + checkInDay +'&stay_nights='+ numDays +'&adults='+ adults +'&children='+ children +'&' + linkerParam;
					switch(prop_id) {
						case '1517':
							currentId = "17665";
							bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&child='+ children;
						break;
						case '1518':
							currentId = "17663";
							bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&child='+ children;
							
						break;
						case '1519':

						currentId = "17662";
						bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&children='+ children;
	
						break;
						case '1696':
							currentId = "17664";
							bookingURL = 'https://res.windsurfercrs.com/ibe/index.aspx?propertyID='+currentId+'&checkin='+ checkInMonthAdj  + '-' + checkInDay + '-' +  checkInYear +'&stay_nights='+ numDays +'&adults='+ adults +'&child='+ children;
							
							break;
					}
					break;
			}

			window.open(bookingURL, '_blank');
		});
	

		//Check in and check out datepicker for booking engine
		$( "#arrive" ).datepicker({
			changeMonth: true,
            dateFormat: 'mm/dd/yy',
            numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#depart" ).datepicker( "setDate", newDate );
				$( "#depart" ).datepicker( "option", "minDate", selectedDate );
				//if(selectedDate.length>0 && $( "#depart" ).val().length>0){
					$("#nights").val(getNumberPerNight($( "#depart" ).val(),selectedDate))
				//}
			}
		});
		$( "#depart" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: 'mm/dd/yy',
            changeMonth: true,
			numberOfMonths: 1,
			onSelect:function(selectedDate){
				//if(selectedDate.length>0 && $( "#arrive" ).val().length>0){
					$("#nights").val(getNumberPerNight($( "#arrive" ).val(),selectedDate));
				//}
			}
		});
			

	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
} 

function getNumberPerNight(sdate1,sdate2){
	let date1 = new Date(sdate1);
	let date2 = new Date(sdate2);//"07-30-2019"
	
	// To calculate the time difference of two dates
	let Difference_In_Time = date2.getTime() - date1.getTime();

	// To calculate the no. of days between two dates
	return Math.abs(Difference_In_Time / (1000 * 3600 * 24));
}

function weather(){
	let state = 'Michigan'
	switch (site_id) {
		case 1512:
		case 1517:
		case 1519:
			state ='Petoskey'
			break;
		case 1520:
			state ='Harbor Springs'
			break;
		case 1521:
			state ='Charlevoix'
			break;
		case 1518:
			state ='Alanson'
			break;
		case 1523:
			state ='Michigan'
			break;
	}
	
	let weather_grades = document.getElementsByClassName('weather__temp');
	fetch(`https://api.openweathermap.org/data/2.5/weather?q=${state},us&APPID=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial`)
	.then(function (response) {
		return response.json();
	})
	.then(function (myJson) {
		[...weather_grades].forEach(function(item){
			item.innerHTML=parseInt(myJson.main.temp) + '°F';
		})
	});
}

function openLightbox() {
	let openLightboxButton = document.querySelector('#active-lightbox-button');
	openLightboxButton.click();
}